<div class="content h-full flex flex-col items-center justify-center">
  <div>
    <span>
      <img src="/assets/icons/svg/ic-warning-grey.svg" alt="Warning icon" />
    </span>
    <h2 class="text-xl lg:text-2xl font-bold leading-normal mb-2 lg:mb-0">
      {{ 'surveyPreview.screenOutMessage' | translate }}
    </h2>
    <p
      class="text-sm lg:text-xl mb-0 font-semibold lg:font-normal leading-normal"
    >
      {{ 'surveyPreview.screenOutDescription' | translate }}
    </p>
    <p
      class="text-sm lg:text-xl mb-8 font-semibold lg:font-normal leading-normal"
    >
      {{ 'surveyPreview.screenOutDescription2' | translate }}
    </p>
    <p
      class="text-sm lg:text-xl mb-6 font-semibold lg:font-normal leading-normal"
    >
      {{ 'surveyPreview.mayCloseWindow' | translate }}
    </p>
    <button (click)="onRestartSurvey()">Restart</button>
  </div>
</div>
